if (!customElements.get("cookie-creator")) {
  customElements.define(
    "cookie-creator",
    class CookieCreator extends HTMLElement {
      constructor() {
        super();

        this.state = {
          dough: null,
          filling: null,
          fillingDouble: false,
          fillingChunks: null,
          fillingChunksDouble: false,
          topping: null,
          toppingDouble: false,
          name: null,
          loading: false,
        };

        this.querySelectorAll(".selection-grid-item").forEach((element) => {
          element.addEventListener(
            "click",
            this.handleComponentSelection.bind(this)
          );
        });
        this.cookieText = this.querySelector(".cookie-content p");
        this.cookiePrice = this.querySelector(".cookie-content strong");
        this.addToCartButtons = this.querySelectorAll(".add-to-cart");
        this.addToCartButtons.forEach((element) => {
          element.addEventListener("click", this.handleAddToCart.bind(this));
        });
        this.cartNotification = document.querySelector("cart-notification");

        this.querySelector("#filling-double").addEventListener(
          "input",
          (event) => {
            this.handleDoubleSelection("filling", event.target.checked);
          }
        );
        this.querySelector("#filling-chunks-double").addEventListener(
          "input",
          (event) => {
            this.handleDoubleSelection("filling-chunks", event.target.checked);
          }
        );
        this.querySelector("#topping-double").addEventListener(
          "input",
          (event) => {
            this.handleDoubleSelection("topping", event.target.checked);
          }
        );
        this.querySelector("#cookie-name").addEventListener(
          "input",
          (event) => {
            this.state.name = event.target.value;
            this.update();
          }
        );

        this.update();
      }

      handleDoubleSelection(type, isSelected) {
        if (type === "filling") {
          this.state.fillingDouble = isSelected;
        } else if (type === "filling-chunks") {
          this.state.fillingChunksDouble = isSelected;
        } else if (type === "topping") {
          this.state.toppingDouble = isSelected;
        }
        this.update();
      }

      getProductId() {
        const dough = CreatorConfig.bases[this.state.dough].id;
        const filling = this.state.filling ? CreatorConfig.fillings[this.state.filling].id : null;
        const fillingChunks = this.state.fillingChunks
          ? CreatorConfig.chunks[this.state.fillingChunks].id
          : null;
        const topping = this.state.topping
          ? CreatorConfig.toppings[this.state.topping].id
          : null;

        const config = fetchConfig("javascript");
        config.body = JSON.stringify({
          dough,
          filling,
          fillingDouble: this.state.fillingDouble,
          fillingChunks,
          fillingChunksDouble: this.state.fillingChunks
            ? this.state.fillingChunksDouble
            : false,
          topping,
          toppingDouble: this.state.topping ? this.state.toppingDouble : false,
        });

        return fetch(`/a/cookie/create`, config).then((response) =>
          response.json()
        );
      }

      handleAddToCart(event) {
        if (this.state.loading) return;
        this.state.loading = true;
        this.update();

        const dough = CreatorConfig.bases[this.state.dough];
        const filling = this.state.filling ? CreatorConfig.fillings[this.state.filling] : null;
        const fillingChunks = this.state.fillingChunks
          ? CreatorConfig.chunks[this.state.fillingChunks]
          : null;
        const topping = this.state.topping
          ? CreatorConfig.toppings[this.state.topping]
          : null;

        this.cartNotification.setActiveElement(document.activeElement);

        this.getProductId()
          .then(({ variant_id }) => {
            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            config.body = JSON.stringify({
              sections: this.cartNotification
                .getSectionsToRender()
                .map((section) => section.id),
              sections_url: window.location.pathname,
              items: [
                {
                  id: variant_id,
                  quantity: 1,
                  properties: {
                    Name: this.state.name,
                    Teig: dough.title,
                    Füllung:
                      filling ? (filling.title +
                      (this.state.fillingDouble ? " (doppelt)" : "")) : undefined,
                    "Chunks in der Füllung": fillingChunks
                      ? fillingChunks.title +
                        (this.state.fillingChunksDouble ? " (doppelt)" : "")
                      : undefined,
                    Topping: topping
                      ? topping.title +
                        (this.state.toppingDouble ? " (doppelt)" : "")
                      : undefined,
                  },
                },
              ],
            });

            return fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  this.handleErrorMessage(response.description);
                  return;
                }

                response.id = response.items[0].id;
                this.cartNotification.renderContents(response);
              });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.state.loading = false;
            this.update();
          });
      }

      handleComponentSelection(event) {
        const data = event.target.closest(".selection-grid-item").dataset;
        if (this.state[data.type] === data.handle) {
          this.state[data.type] = null;
        } else {
          this.state[data.type] = data.handle;
        }
        this.update();
      }

      isComplete() {
        return (
          this.state.dough &&
          this.state.name !== null &&
          this.state.name !== ""
        );
      }

      update() {
        ["dough", "filling", "fillingChunks", "topping"].forEach((type) => {
          const currentlySelected = this.querySelector(
            `.selection-grid-item[data-type="${type}"].selected`
          );
          if (currentlySelected) currentlySelected.classList.remove("selected");

          const value = this.state[type];
          if (value === null) return;

          this.querySelector(
            `.selection-grid-item[data-type="${type}"][data-handle="${value}"]`
          ).classList.add("selected");
        });

        const isSet = (v) => v !== null;
        const base = isSet(this.state.dough)
          ? CreatorConfig.bases[this.state.dough].title
          : "";
        const filling = isSet(this.state.filling)
          ? `, ${this.state.fillingDouble ? "doppelt " : ""}${
              CreatorConfig.fillings[this.state.filling].title
            }`
          : "";
        const fillingChunks = isSet(this.state.fillingChunks)
          ? ` mit ${this.state.fillingChunksDouble ? "doppelt " : ""}${
              CreatorConfig.chunks[this.state.fillingChunks].title
            }`
          : "";
        const topping = isSet(this.state.topping)
          ? `, topped mit ${this.state.toppingDouble ? "doppelt " : ""}${
              CreatorConfig.toppings[this.state.topping].title
            }`
          : "";

        this.cookieText.innerHTML = `
          <strong>${base}</strong>${filling}${fillingChunks}${topping}
        `;

        let price = 0;
        if (this.state.dough) price += 240;
        if (this.state.filling)
          price += 80 * (this.state.fillingDouble ? 2 : 1);
        if (this.state.fillingChunks)
          price += 35 * (this.state.fillingChunksDouble ? 2 : 1);
        if (this.state.topping)
          price += 35 * (this.state.toppingDouble ? 2 : 1);

        this.cookiePrice.innerHTML = accounting.formatMoney(
          price / 100,
          "€",
          2,
          ".",
          ","
        );

        this.addToCartButtons.forEach((element) => {
          if (this.isComplete()) {
            element.classList.remove("hidden");
          } else {
            element.classList.add("hidden");
          }

          if (this.state.loading) {
            element.setAttribute("aria-disabled", true);
            element.classList.add("loading");
            element.innerHTML = "Bitte warten";
          } else {
            element.setAttribute("aria-disabled", false);
            element.classList.remove("loading");
            element.innerHTML = "Zum Warenkorb hinzufügen";
          }
        });
      }
    }
  );
}
